import React, {useState, useEffect} from 'react'
import { useHistory } from 'react-router'
import './Nav.css'

const Nav = () => {

    const avatar = 'https://pbs.twimg.com/profile_images/1240119990411550720/hBEe3tdn_400x400.png'

    const[show, handleShow] = useState(false)
    const history = useHistory()

    const transitionNavBar = () => {
        if(window.scrollY > 100){
            handleShow(true)
        }else{
            handleShow(false)
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', transitionNavBar)
        return () => window.removeEventListener('scroll', transitionNavBar) 
    }, [])

    return (
        <div className={`nav ${show && 'nav_black'}`}>
            <div className='nav_contents'>
                <img
                    onClick={() => history.push('/')}
                    className='nav_logo'
                    src='https://www.abacustechnologies.com/wp-content/uploads/2020/05/580b57fcd9996e24bc43c529.png'
                    alt='Netflix' 
                />
                <img
                    onClick={() => history.push('/profile') }
                    className='nav_avatar' 
                    src={avatar}
                    alt='avatar' />
            </div>
        </div>
    )
}

export default Nav
